import { getBrandingEnabled } from '@/src/lib/utils/branding.utils.ts';
import { logoClaimConfig, logoConfig } from '@/src/app/components/Logo/logo.constants.ts';
import { Branding } from '@/src/lib/utils/branding.types.ts';

export function getLogoClaimConfig() {
  const type = getBrandingEnabled();

  return logoClaimConfig[type as Branding];
}

export function getLogoConfig() {
  const type = getBrandingEnabled();

  return logoConfig[type as Branding];
}
